module.exports = __webpack_public_path__ + "static/media/paper-plane.7ecce613.svg";